import { render, staticRenderFns } from "./UpdateBanner.vue?vue&type=template&id=0d9bab8a"
import script from "./UpdateBanner.vue?vue&type=script&lang=js"
export * from "./UpdateBanner.vue?vue&type=script&lang=js"
import style0 from "./UpdateBanner.vue?vue&type=style&index=0&id=0d9bab8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports